import { useContext } from 'react';

import { ViewContext } from '@/state/contexts';

const ActionButton = ({
	leftEmoji = '',
	leftText = '',
	rightText = '',
	onClickFunc,
}) => {
	const { verboseSettings }: any = useContext(ViewContext);

	return (
		<button className="split-button" onClick={onClickFunc}>
			<span className="left-text">
				{leftEmoji}
				{verboseSettings && <> {leftText}</>}
			</span>
			{rightText != null && rightText != '' && (
				<span className="right-text">
					{verboseSettings && rightText}
				</span>
			)}
		</button>
	);
};

export default ActionButton;
